module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "empresa"
    }
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.empresas
    },
    model: {
      value: (_vm.empresaSelecionada),
      callback: function($$v) {
        _vm.empresaSelecionada = $$v
      },
      expression: "empresaSelecionada"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome Completo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.name),
      expression: "dados.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('login')
    }
  }, [_c('label', {
    attrs: {
      "for": "login"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.login),
      expression: "dados.login"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "login",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "login", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.email),
      expression: "dados.email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.password),
      expression: "dados.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "type": "password",
      "disabled": _vm.atualizacao
    },
    domProps: {
      "value": (_vm.dados.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('confirmacao')
    }
  }, [_c('label', {
    attrs: {
      "for": "confirmacao"
    }
  }, [_vm._v("Redigite a Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.controle.confirmacao_senha),
      expression: "controle.confirmacao_senha"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "confirmacao",
      "type": "password",
      "disabled": _vm.atualizacao
    },
    domProps: {
      "value": (_vm.controle.confirmacao_senha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.controle, "confirmacao_senha", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmacao')),
      expression: "errors.has('confirmacao')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('nivel')
    }
  }, [_c('label', {
    attrs: {
      "for": "nivel"
    }
  }, [_vm._v("Nível")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nivel),
      expression: "dados.nivel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nivel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "nivel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Usuário")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Administrador")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nivel')),
      expression: "errors.has('nivel')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "tag": "button",
      "to": "/administracao/usuarios"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.salvar()
      }
    }
  }, [_vm._v("Salvar")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Novo Usuário")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f23cfb4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/usuarios/form.vue
// module id = 418
// module chunks = 1